import React from 'react'
import { Grid } from '@material-ui/core'
import { Field, FieldArray, FieldWrapper } from '@progress/kendo-react-form'
import { Input } from '@progress/kendo-react-inputs'
import { DatePickerField } from '../index'
import { Placeholder, Headline, StyledPaper, InnerGrid, SafeTextArea, SafeCheckbox } from '../styled/FormComponents'
import ProjectSuppliersForm from './ProjectSuppliersForm'

export default (props) => {
    const { spaceBetweenGrids, form } = props
    return <Grid container spacing={spaceBetweenGrids}>
        <InnerGrid item md={4}>
            <StyledPaper>
                <Headline>Bezeichnung</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <Field name="project.mediaNumber" component={Input} label="Mediennr. / Prospektnr."/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <Field name="project.title" component={Input} label="Projektbezeichnung" type="text"/>
                    </InnerGrid>
                </Grid>
            </StyledPaper>
            <StyledPaper>
                <Headline>Auftraggeber</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <Field name="project.customerDepartment" component={Input} label="Abteilung"/>
                        <Field name="project.customerCostCenter" component={Input} label="Kostenstelle"/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <Field name="project.customerName" component={Input} label="Ansprechpartner" type="text"/>
                        <Field name="project.customerWANumber" component={Input} label="WA-Nummer"/>
                    </InnerGrid>
                </Grid>
            </StyledPaper>
            <StyledPaper>
                <Headline>Sachbearbeiter</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <Field name="project.inChargeDepartment" component={Input} label="Abteilung"/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <Field name="project.inChargeName" component={Input} label="Ansprechpartner"/>
                    </InnerGrid>
                </Grid>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={4}>
            <StyledPaper>
                <Headline>Freigabe</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <Placeholder height="10px"/>
                        <FieldWrapper>
                            <Field name="project.reviewStarted" component={SafeCheckbox} label="Review-Umlauf gestartet"/>
                        </FieldWrapper>
                        <Placeholder height="10px"/>
                        <FieldWrapper>
                            <Field name="project.releaseStarted" component={SafeCheckbox} label="Release-Umlauf gestartet"/>
                        </FieldWrapper>
                        <Placeholder height="10px"/>
                        <FieldWrapper>
                            <Field name="project.approved" component={SafeCheckbox} label="Umlauf beendet / Freigabe erteilt"/>
                        </FieldWrapper>
                        <Placeholder height="38px"/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <FieldWrapper>
                            <Field name="project.dataArchived" component={SafeCheckbox} label="Daten archiviert"/>
                        </FieldWrapper>
                        <Placeholder height="10px"/>
                        <FieldWrapper>
                            <Field name="project.extranetPdfProvided" component={SafeCheckbox} label="Extranet PDF bereitgestellt"/>
                        </FieldWrapper>
                    </InnerGrid>
                </Grid>
            </StyledPaper>
            <StyledPaper>
                <Headline>Druck Auftrag</Headline>
                <Grid container spacing={spaceBetweenGrids}>
                    <InnerGrid item md={6}>
                        <Field name="project.printOrderTo" component={Input} label="Auftrag geht an"/>
                        <DatePickerField name="project.printOrderNegotiatedDelivery" label="Liefertermin" form={form}/>
                        <Field name="project.printOrderPricePerItem" component={Input} label="Preis pro Stück"/>
                    </InnerGrid>
                    <InnerGrid item md={6}>
                        <DatePickerField name="project.printOrderDataSentDate" label="Daten/Film an Druckerei"
                                         form={form}/>
                        <Field name="project.printOrderDeliveredVolume" component={Input}
                               label="Stück Lieferung"/>
                        <DatePickerField name="project.printOrderDeliveryDate" label="Geliefert am" form={form}/>
                    </InnerGrid>
                </Grid>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={4}>
            <StyledPaper>
                <Headline>Sonstiges</Headline>
                <Placeholder height="10px"/>
                <Field component={SafeTextArea} multiline rows={5} id="dataHoldingSupplier"
                       name="project.dataHoldingSupplier"
                       variant="outlined"
                       fullWidth
                       label="Bei welchem Dienstleister befinden sich die Daten?"/>
                <Placeholder height="25px"/>
                <Field component={SafeTextArea} multiline rows={7} id="remarks" name="project.remarks"
                       variant="outlined"
                       fullWidth
                       label="Anmerkungen / Besonderheiten"/>
                <Placeholder height="19px"/>
            </StyledPaper>
        </InnerGrid>
        <InnerGrid item md={12}>
            <FieldArray name="projectSuppliers" component={ProjectSuppliersForm} form={form}/>
        </InnerGrid>
    </Grid>
}



// WEBPACK FOOTER //
// ./src/components/dialog/ProjectDataForm.js